import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import SectionChart from '../shared/sectionChart/SectionChart';
import SectionHero from '../shared/sectionHero/SectionHero';
import LocationOffered from './charts/LocationOffered';
import MostOfferedPerks from './charts/MostOfferedPerks';
import MostWantedRoles from './charts/MostWantedRoles';
import SalaryOfferedVsWanted from './charts/SalaryOfferedVsWanted';
import { StyledSection } from './Companies.styled';

const Companies: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');

  return (
    <StyledSection>
      <SectionHero
        image={getPublicPath('/images/stateSector/2024/companies.png')}
        title={t('mantechcar24.companies.hero.title')}
        desc={t('mantechcar24.companies.hero.desc')}
      />
      <SectionChart
        title={t('mantechcar24.companies.salary-offered-wanted.title')}
        desc={t('mantechcar24.companies.salary-offered-wanted.desc')}
        descExtra={t('mantechcar24.companies.salary-offered-wanted.descExtra')}
        shareId="salaryofferedvswanted"
        emailSubject={t(
          'mantechcar24.share-modal.salary-offered-wanted.email-subject'
        )}
        emailMessage={t(
          'mantechcar24.share-modal.salary-offered-wanted.email-text'
        )}
        shareMessage={t('mantechcar24.share-modal.salary-offered-wanted.text')}
      >
        <SalaryOfferedVsWanted />
      </SectionChart>
      <SectionChart
        title={t('mantechcar24.companies.most-wanted-roles.title')}
        desc={t('mantechcar24.companies.most-wanted-roles.desc')}
        descExtra={t('mantechcar24.companies.most-wanted-roles.descExtra')}
        shareId="mostwantedroles"
        emailSubject={t(
          'mantechcar24.share-modal.most-wanted-roles.email-subject'
        )}
        emailMessage={t(
          'mantechcar24.share-modal.most-wanted-roles.email-text'
        )}
        shareMessage={t('mantechcar24.share-modal.most-wanted-roles.text')}
      >
        <MostWantedRoles />
      </SectionChart>
      <SectionChart
        title={t('mantechcar24.companies.most-offered-perks.title')}
        desc={t('mantechcar24.companies.most-offered-perks.desc')}
        descExtra={t('mantechcar24.companies.most-offered-perks.descExtra')}
        shareId="mostofferedperks"
        emailSubject={t(
          'mantechcar24.share-modal.most-offered-perks.email-subject'
        )}
        emailMessage={t(
          'mantechcar24.share-modal.most-offered-perks.email-text'
        )}
        shareMessage={t('mantechcar24.share-modal.most-offered-perks.text')}
      >
        <MostOfferedPerks />
      </SectionChart>
      <SectionChart
        title={t('mantechcar24.companies.locations-offered.title')}
        desc={t('mantechcar24.companies.locations-offered.desc')}
        shareId="locationoffered"
        emailSubject={t(
          'mantechcar24.share-modal.locations-offered.email-subject'
        )}
        emailMessage={t(
          'mantechcar24.share-modal.locations-offered.email-text'
        )}
        shareMessage={t('mantechcar24.share-modal.locations-offered.text')}
      >
        <LocationOffered />
      </SectionChart>
    </StyledSection>
  );
};

export default Companies;
